/**
 * Application configuration
 * All environment-dependent values should be defined here.
 */

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://agi-production.fly.dev';
export const API = `${BACKEND_URL}/api`;

export const API_BASE = process.env.REACT_APP_API_URL || '/api';

export const WS_BASE = process.env.REACT_APP_WS_URL ||
  `wss://${window.location.hostname}:${process.env.REACT_APP_WS_PORT || '8000'}`;

export const config = {
  apiBase: API_BASE,
  wsBase: WS_BASE,
};

export default config;
